import React from 'react'
import * as setupWarning from '../../Constants/Constants'
const SetupWarning = (props) => {
  return (
    <div className="alert alert-warning" role="alert">
        {setupWarning.setupWarning}
    </div>
  )
}

export default SetupWarning
